// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';

export async function efectyOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {

  return {
    payment_type: 'cash',
    payment_type_code: 'efecty',
    instalments: '1',
  };
}
